import { create } from "zustand";
export const useClaimsStore = create((set) => ({
  claims: null,
  claim: null,
  filter: {
    fulltext: "",
    state: [],
    date_from: "",
    date_to: "",
  },
  setClaims: (claims) => set({ claims }),
  setClaim: (claim) => set({ claim }),
  setFilter: (filter) => set({ filter }),
}));
